// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"_1PbK8","open":"_26dpm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/V2/dropdown/styles.module.css
// module id = 212
// module chunks = 0